import React from "react";
import useAxios from "axios-hooks";
import { useParams } from "react-router-dom";
import DiscoverabilityList from "./DiscoverabilityList";
import { Text, Stack } from "@fluentui/react";
import FeatureSummary from "../../../../Util/FeatureSummary";

const DiscoverabilityPage = () => {
  let { actionItemId } = useParams();

  const [{ data, loading }] = useAxios({
    url: `action-item/${actionItemId}`,
    method: "get",
  });

  if (loading) return <div>Loading...</div>;
  return (
    <Stack tokens={{ childrenGap: 5 }}>
      <Text block as="h1" variant="xLarge" nowrap>
        Discoverability
      </Text>
      <Text>
        This is a list of all the checklists that this action item belongs to
      </Text>
      <DiscoverabilityList data={data} />
      <FeatureSummary
        label="About Action Item Discoverability"
        summary="View which checklists include this action item. This helps you understand where the action item appears across your platform and impacts to users if you modify or delete it."
      />
    </Stack>
  );
};

export default DiscoverabilityPage;
